/* Materia Viva · tienda.js — portado del mock v16 */
function abrirMenu(){document.getElementById('menu').classList.add('on');
  document.getElementById('ov').classList.add('on');
  document.getElementById('btnMenu').setAttribute('aria-expanded','true')}
function cerrarMenu(){document.getElementById('menu').classList.remove('on');
  document.getElementById('ov').classList.remove('on');
  document.getElementById('btnMenu').setAttribute('aria-expanded','false')}
document.addEventListener('keydown',function(e){if(e.key==='Escape')cerrarMenu()});

/* ═══ FICHA DE PRODUCTO ═══════════════════════════════════════════════════
   Dos cosas: elegir variante y mover el carrusel.

   LA TALLA NO VIENE ELEGIDA. Antes el HTML marcaba una por omisión y el campo
   de variante salía lleno: se podía añadir al carrito una talla que nadie
   escogió, y la persona se enteraba al recibirla.

   > Una opción preseleccionada no es una comodidad: es una decisión que
   > alguien va a creer que tomó.

   Así que el campo nace vacío, el botón nace apagado y dice qué falta. Al
   elegir, la lista se pliega —ya cumplió— y queda un renglón con lo elegido. */
(function(){
  var datos = document.getElementById('datosProducto'); if (!datos) return;
  var variantes = JSON.parse(datos.textContent);
  var add = document.getElementById('btnAdd');
  var campo = document.getElementById('idVariante');
  var grupos = [].slice.call(document.querySelectorAll('.selgrp'));
  var sel = grupos.map(function(){ return null; });

  /* EL BOTÓN LLEVA DOS COSAS ADENTRO (15-sep): el texto y las rayitas de los
     pasos, una por grupo. Se arman una vez y `pinta` sólo las actualiza; antes
     `textContent` borraba todo lo que hubiera adentro en cada cambio. */
  var txt = document.createElement('span'); txt.className = 'txt';
  txt.textContent = add.textContent.trim();
  var paso = document.createElement('span'); paso.className = 'paso'; paso.setAttribute('aria-hidden', 'true');
  var rayas = grupos.map(function(){ var i = document.createElement('i'); paso.appendChild(i); return i; });
  /* Las rayitas sólo cuando hay DOS pasos o más (piedra y talla). Con uno solo
     —Materia, aretes— una rayita sola decía «te falta elegir algo» sin decir
     qué, y el texto ya lo dice completo: «Elige tu talla». */
  add.textContent = ''; add.appendChild(txt); if (grupos.length > 1) add.appendChild(paso);

  /* El siguiente paso se queda encendido (`.sig`): el primer grupo sin elegir,
     siempre que ya se haya elegido alguno. Con dos pasos y nada elegido no se
     enciende nada (el primero es obvio); con UN solo paso —Materia, aretes— se
     enciende desde el principio, porque ese único paso es el que hay que dar.
     Ver estilo.css. */
  function enciende(){
    var alguno = grupos.length === 1 || sel.some(function(s){ return s !== null; });
    var puesto = false;
    grupos.forEach(function(g, k){
      var va = alguno && !puesto && sel[k] === null;
      g.classList.toggle('sig', va);
      if (va) puesto = true;
    });
  }

  function variante(){
    if (sel.some(function(s){ return s === null; })) return null;
    for (var k = 0; k < variantes.length; k++){
      var ok = true;
      for (var j = 0; j < sel.length; j++) if (variantes[k].options[j] !== sel[j]) ok = false;
      if (ok) return variantes[k];
    }
    return null;
  }
  function falta(){
    for (var k = 0; k < grupos.length; k++) if (sel[k] === null)
      return grupos[k].querySelector('.lbl span').textContent.toLowerCase();
    return '';
  }
  function pinta(){
    var v = variante();
    campo.value = v ? v.id : '';
    /* Sin centavos. El formato de moneda de la tienda es `${{amount_no_decimals}}`
       (Configuración → Datos de la tienda → Formato de moneda), así que Liquid pinta
       $1,500 y aquí hay que pintar exactamente lo mismo: si el JS mete «.00», el
       precio cambia de forma al elegir talla y parece que cambió de número. Esto
       estuvo al revés hasta el 5-sep, cuando el formato de la tienda traía centavos. */
    if (v) document.getElementById('pPrecio').innerHTML =
      '$' + Math.round(v.price / 100).toLocaleString('es-MX') +
      ' <span>MXN · envío incluido</span>';
    var listo = !!v && v.available !== false;
    /* Mientras falta algo el botón NO se apaga: se queda vivo (`.falta`) para
       que el toque lleve a lo que falta —ver el `submit` de abajo—. Sólo
       «Agotada» se apaga de verdad, porque ahí no hay nada que el toque pueda
       arreglar. El `disabled` que traía de Liquid se quita aquí: ya hay JS. */
    add.disabled = !!v && v.available === false;
    add.classList.toggle('falta', !v);
    /* `.listo` sólo al PASAR a listo: dispara la animación de llenado una vez */
    if (listo && !add.classList.contains('listo')) add.classList.add('listo');
    if (!listo) add.classList.remove('listo');
    add.setAttribute('aria-disabled', listo ? 'false' : 'true');
    txt.textContent = listo ? 'Añadir al carrito'
      : (v ? 'Agotada' : 'Elige tu ' + falta());
    rayas.forEach(function(r, k){ r.classList.toggle('ok', sel[k] !== null); });
    enciende();
  }

  /* ── LAS DOS FOTOS SIGUEN A LA PIEDRA ──
     El carrusel tiene dos ranuras fijas —la pieza y la pieza puesta— y al
     elegir piedra cambia lo que vive en cada una. Se precarga antes de cambiar
     el src: si no, la ranura parpadea en blanco mientras baja la foto nueva, y
     ese parpadeo se lee como que algo se rompió. */
  var mapaFotos = null;
  var nodoFotos = document.getElementById('fotosPiedra');
  if (nodoFotos) { try { mapaFotos = JSON.parse(nodoFotos.textContent); } catch (e) { mapaFotos = null; } }

  /* `srcset` LE GANA A `src`. Cuando el visor se volvió responsivo (8-sep) esta
     función dejó de verse: seguía cambiando la fuente, y el navegador seguía
     pintando la foto que ya había escogido de la lista de tamaños. La foto no
     cambiaba de piedra y nada avisaba, porque técnicamente el `src` sí cambió.

     > Con `srcset` puesto, `src` deja de ser la fuente de la imagen y pasa a ser
     > el respaldo para navegadores viejos. Hay que reescribir la lista.

     Los anchos son los mismos que pinta la plantilla; las URLs del mapa vienen
     con `&width=1200`, así que basta sustituir ese número. */
  var ANCHOS_VISOR = [400, 600, 800, 1000, 1200, 1600];
  function listaTamanos(url){
    return ANCHOS_VISOR.map(function(a){
      return url.replace(/([?&]width=)\d+/, '$1' + a) + ' ' + a + 'w';
    }).join(', ');
  }
  function cambiaFoto(img, url){
    if (!img || !url || img.getAttribute('src') === url) return;
    img.style.transition = 'opacity .18s';
    img.style.opacity = '0';
    /* Se espera al `load` de la PROPIA imagen, no al de una precarga aparte: con
       `srcset` la que el navegador escoge puede no ser la que precargamos. */
    var listo = function(){ img.style.opacity = '1'; };
    img.addEventListener('load', listo, { once: true });
    img.addEventListener('error', listo, { once: true });
    if (img.getAttribute('srcset')) img.setAttribute('srcset', listaTamanos(url));
    img.src = url;
  }

  function pintaFotos(piedra){
    if (!mapaFotos || !mapaFotos[piedra]) return;
    var par = mapaFotos[piedra];
    var car = document.getElementById('pCar');
    if (!car) return;
    cambiaFoto(car.querySelector('.pslide[data-foto="campo"] img'), par[0]);
    cambiaFoto(car.querySelector('.pslide[data-foto="mano"] img'), par[1]);
    /* No se regresa a la primera foto. Si estabas viendo la mano y cambias de
       piedra, lo que quieres es la mano de la piedra nueva; devolverte al inicio
       te obliga a volver a deslizar cada vez que comparas. */
  }

  grupos.forEach(function(g, i){
    var lista = g.querySelector('.ejes');
    lista.addEventListener('click', function(e){
      var b = e.target.closest('button');
      if (!b || b.classList.contains('med')) return;   // «mídela» no es una talla
      lista.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on');
      sel[i] = b.dataset.valor;
      var eleg = g.querySelector('.elegido');
      if (!b.dataset.muestra) eleg.textContent = b.dataset.valor;
      /* La talla se pliega —ya cumplió— pero la piedra NO: elegir color es
         comparar, y comparar con la lista plegada cuesta dos toques por color.
         Los seis discos se quedan a la vista todo el tiempo. */
      /* el grupo de piedra se reconoce por sus discos, no por el rótulo: el rótulo
         dice «Piedra» en Lobelia y «Combinación» en Mitosis */
      if (g.querySelector('.piedras')){
        var rot = g.querySelector('.nombre');
        if (rot) rot.innerHTML = '<b>' + b.dataset.valor + '</b>';
        pintaFotos(b.dataset.valor);
      } else {
        /* la elegida sube al rótulo, como la piedra: «TALLA · 6.5» */
        var lbl = g.querySelector('.lbl'), tsel = lbl && lbl.querySelector('.tsel');
        if (lbl && !tsel){ tsel = document.createElement('span'); tsel.className = 'tsel'; lbl.appendChild(tsel); }
        if (tsel) tsel.textContent = b.dataset.valor;
      }
      if (lista.scrollWidth > lista.clientWidth + 2){   // tallas Y piedras: la elegida se centra
        /* YA NO SE PLIEGA (8-sep). En el teléfono las tallas son una tira de una
           fila que se desliza; plegarla ahorraba nada y escondía las vecinas. Lo
           que sí: la elegida se centra, para que si dudas entre 6 y 6.5 las veas
           juntas sin volver a buscar. `block:'nearest'` para no mover la página. */
        /* v101: suave sólo si lo tocó una persona. Cuando la elige el código (la
           talla que regresa del medidor, `b.click()`), el `scrollIntoView` de la
           página que viene justo después cortaba el deslizamiento a medias, y
           como la tira ya no nace en la 4 sino en la 7, la talla 5 quedaba
           escondida en la orilla. Al instante no hay nada que cortar. */
        b.scrollIntoView({ inline: 'center', block: 'nearest', behavior: e.isTrusted ? 'smooth' : 'auto' });
      }
      pinta();
    });
    /* el desvanecido de la tira sólo esconde lo que de verdad sigue: al inicio
       no se desvanece la izquierda, al final no se desvanece la derecha */
    function bordes(){
      var s = lista.scrollLeft, max = lista.scrollWidth - lista.clientWidth;
      lista.classList.toggle('al-inicio', s <= 2);
      lista.classList.toggle('al-final', max - s <= 2);
    }
    /* LA TIRA DE TALLAS NACE EN EL CENTRO (v101, 1-oct). Empezaba en la 4: para
       llegar a la 7 —la más vendida, junto con la 6.5— había que deslizar, y como
       a la izquierda no había nada no se notaba que la tira se mueve a los dos
       lados. Ahora arranca con la 7 al centro (o la de en medio si un anillo no
       la tiene), SIN elegirla: nadie compra una talla que no escogió. Sólo se
       mueve el scroll de la tira, sin animación y sin mover la página; se mide
       con getBoundingClientRect porque offsetLeft depende de quién sea el padre
       posicionado. Si después llega una talla por URL (el medidor), su clic la
       centra encima de esto. En la compu la tira es retícula y no desborda: no
       entra aquí. */
    if (lista.classList.contains('tallasel') && lista.classList.contains('rejilla')
        && lista.scrollWidth > lista.clientWidth + 2){
      var tallas = lista.querySelectorAll('button[data-valor]');
      var centro = lista.querySelector('button[data-valor="7"]') || tallas[Math.floor(tallas.length / 2)];
      if (centro){
        var rl = lista.getBoundingClientRect(), rc = centro.getBoundingClientRect();
        lista.scrollLeft += (rc.left + rc.width / 2) - (rl.left + rl.width / 2);
      }
    }
    if (lista.classList.contains('rejilla')){
      lista.addEventListener('scroll', bordes, { passive: true });
      window.addEventListener('resize', bordes);
      bordes();
    }
    var rotulo = g.querySelector('.nombre');
    if (rotulo){
      lista.addEventListener('mouseover', function(e){
        var b = e.target.closest('button');
        if (b && sel[i] === null) rotulo.innerHTML = b.dataset.valor;
      });
      lista.addEventListener('mouseleave', function(){
        if (sel[i] === null) rotulo.textContent = rotulo.dataset.vacio || 'toca una piedra';
      });
    }
    /* El grupo de piedra no lleva «cambiar», porque nunca se pliega. Sin este
       guardia, buscarlo devuelve null, el listener revienta y —al estar dentro
       del forEach— se lleva por delante TODO lo que va después: la talla nunca
       se conecta, el botón nunca se enciende y el carrusel nunca arranca. Un
       elemento opcional siempre se pregunta antes de usarse. */
    var cambiar = g.querySelector('.cambiar');
    if (cambiar) cambiar.addEventListener('click', function(){
      g.classList.remove('plegado');
    });
  });

  /* EL TOQUE CUANDO FALTA ALGO ES LA GUÍA (15-sep). Como el botón ya no se
     apaga, tocarlo envía la forma; aquí se detiene, se baja al grupo que falta
     y se enciende un momento (`.guia`, ver estilo.css). Antes el botón apagado
     no hacía nada, y en Clarity se veía gente tocándolo.
     `campo.value` además de `variante()`: son dos hechos distintos —uno es
     «la combinación existe», el otro «la forma lleva qué mandar»— y el 422
     lo produce el segundo. */
  var forma = document.getElementById('formaProducto');
  var tGuia = null;
  if (forma) forma.addEventListener('submit', function(e){
    if (variante() && campo.value) return;
    e.preventDefault();
    for (var k = 0; k < grupos.length; k++) if (sel[k] === null){
      var g = grupos[k];
      g.classList.remove('plegado');
      g.scrollIntoView({ block: 'center', behavior: 'smooth' });
      /* se quita y se vuelve a poner para que la animación corra otra vez si
         tocan dos veces seguidas */
      g.classList.remove('guia'); void g.offsetWidth; g.classList.add('guia');
      clearTimeout(tGuia); tGuia = setTimeout(function(){ g.classList.remove('guia'); }, 1700);
      return;
    }
  });
  pinta();

  /* ═══ IDA Y VUELTA AL MEDIDOR (v96) ═══════════════════════════════════
     Shopify manda `frame-ancestors 'none'` en TODA la tienda: ninguna página
     suya se puede meter en un iframe, ni desde ella misma. Así murió la capa
     de v93–v95 (Cristóbal vio la página en blanco). El medidor ahora es una
     página de la tienda y se va y se vuelve por URL: al salir se anota lo ya
     elegido en `?sel=`, y el medidor regresa con `?talla=`; aquí se vuelve a
     marcar todo y la talla medida queda elegida sola. Es mejor que la capa:
     nadie tiene que buscar su talla en la tira después de medirla. */
  /* `marcaValor`, no `marca`: más abajo el carrusel ya tiene su propia `marca(n)`
     y dentro de esta función las dos viven juntas. */
  var q = new URLSearchParams(location.search);
  function marcaValor(valor){
    for (var k = 0; k < grupos.length; k++){
      var b = grupos[k].querySelector('button[data-valor="' + String(valor).replace(/"/g, '\\"') + '"]');
      if (b){ b.click(); return grupos[k]; }
    }
    return null;
  }
  if (q.has('sel') || q.has('talla')){
    try { JSON.parse(q.get('sel') || '[]').forEach(function(v){ if (v !== null) marcaValor(v); }); } catch (e) {}
    var gt = q.get('talla') ? marcaValor(q.get('talla').replace('½', '.5')) : null;
    if (gt) gt.scrollIntoView({ block: 'center' });
    history.replaceState(null, '', location.pathname);
  }
  document.querySelectorAll('.abre-medidor').forEach(function(a){
    a.addEventListener('click', function(e){
      e.preventDefault();
      var volver = location.pathname + '?sel=' + encodeURIComponent(JSON.stringify(sel));
      location.href = a.getAttribute('href').split('?')[0] + '?volver=' + encodeURIComponent(volver);
    });
  });

  /* ── EL CARRUSEL ──
     Se desliza con el dedo (anclaje de CSS); los puntos y las flechas sólo
     mueven el scroll, no mantienen un estado propio: el scroll ES el estado,
     así que no pueden desincronizarse del que se ve. */
  var car = document.getElementById('pCar');
  if (!car) return;
  var puntos = [].slice.call(document.querySelectorAll('#pPuntos button'));
  function actual(){ return car.clientWidth ? Math.round(car.scrollLeft / car.clientWidth) : 0; }
  function marca(){ var n = actual();
    puntos.forEach(function(p, k){ p.classList.toggle('on', k === n); }); }
  function vaA(n){
    n = Math.max(0, Math.min((puntos.length || 1) - 1, n));
    car.scrollTo({ left: n * car.clientWidth, behavior: 'smooth' });
  }
  var t = null;
  car.addEventListener('scroll', function(){
    clearTimeout(t); t = setTimeout(marca, 60);
  }, { passive: true });
  puntos.forEach(function(p, k){ p.addEventListener('click', function(){ vaA(k); }); });
  document.querySelectorAll('.pflecha').forEach(function(f){
    f.addEventListener('click', function(){
      vaA(actual() + (f.classList.contains('der') ? 1 : -1));
    });
  });
})();

/* LA FRANJA DEL 10 % SE TOCA Y APLICA EL CÓDIGO (v99, 21-sep).
   Hasta el 15-sep la franja copiaba el código y decía «pégalo al pagar». En
   Clarity, la compradora de MV-1010 tocó la franja del carrito varias veces
   seguidas (00:29, 00:36) esperando que el descuento apareciera; copiar no era
   lo que esperaba. Ahora un toque APLICA el código: se manda a la puerta que
   Shopify tiene para eso (`/discount/CODIGO?redirect=…`), que guarda el
   descuento para el checkout y regresa a la misma página; en el carrito se ve
   el renglón «descuento · MATERIAVIVA10» y al pagar ya viene puesto. Sigue
   siendo un toque de quien compra (decisión de Cristóbal del 15-sep: nada se
   aplica solo); lo que cambia es que el toque hace lo que promete. */
(function(){
  var f = document.querySelector('.lanzf'); if (!f) return;
  var code = f.querySelector('code'); if (!code) return;
  var codigo = code.textContent.trim();
  f.setAttribute('role', 'button'); f.tabIndex = 0;
  f.setAttribute('aria-label', 'Aplicar el código ' + codigo);
  /* Se acuerda en toda la tienda: aplicado en la ficha, la franja del catálogo y
     la del carrito también dicen «aplicado ✓». Si un día cambia el código, el
     aviso viejo no aplica. En modo privado simplemente no se acuerda. */
  var LLAVE = 'mv-cupon-aplicado';
  function recuerda(){ try { localStorage.setItem(LLAVE, codigo); } catch (e) {} }
  function recordado(){ try { return localStorage.getItem(LLAVE) === codigo; } catch (e) { return false; } }
  function avisa(){
    f.classList.add('copiado');
    f.innerHTML = '<span class="lanzf-c"><code>' + codigo + '</code> aplicado ✓ · lo verás al pagar</span>';
  }
  if (recordado()) avisa();
  function aplica(){
    recuerda(); avisa();
    var volver = location.pathname + location.search;
    location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=' + encodeURIComponent(volver);
  }
  f.addEventListener('click', aplica);
  f.addEventListener('keydown', function(e){
    if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); aplica(); }
  });
})();

/* LA SEGUNDA FOTO DE LA TARJETA SE QUITÓ (29-oct-2026). Aquí vivía el script que la
   descargaba sólo en dispositivos con cursor; sin la foto, el script sobra. */

/* LAS PESTAÑAS DEL CATÁLOGO SON FILTROS, NO PÁGINAS.
   Antes, tocar «collares» recargaba la página entera: pantalla en negro,
   encabezado y franja pintándose otra vez, scroll de vuelta arriba. Para quien
   está comparando piezas —que es a lo que se viene a un catálogo— cada
   comparación costaba una recarga.

   > Cambiar de categoría es aplicar un filtro. Un filtro no recarga la tabla:
   > cambia las filas.

   Ahora se pide sólo la retícula de la otra colección y se cambia en su
   lugar. Las otras tres se precargan cuando el teléfono está ocioso, así que
   el segundo toque es inmediato. Los enlaces siguen siendo enlaces: sin este
   script, o si algo falla, se navega como siempre. La URL cambia con cada
   pestaña para que compartir y el botón «atrás» sigan diciendo la verdad. */
(function(){
  var pest = document.querySelector('.kpest'), rej = document.querySelector('.krej');
  var tit = document.querySelector('.ktitulo');
  if (!pest || !rej || !tit || !window.fetch || !window.DOMParser) return;
  var cache = {};

  function trae(url){
    if (cache[url]) return cache[url];
    return (cache[url] = fetch(url, { credentials: 'same-origin' })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function(html){
        var d = new DOMParser().parseFromString(html, 'text/html');
        var g = d.querySelector('.krej'), t = d.querySelector('.ktitulo');
        if (!g || !t) throw new Error('sin retícula');
        return { grid: g, titulo: t.textContent, title: d.title };
      })
      .catch(function(e){ delete cache[url]; throw e; }));
  }

  function pinta(url, datos, empuja){
    var g = document.querySelector('.krej');
    g.parentNode.replaceChild(datos.grid.cloneNode(true), g);
    rej = document.querySelector('.krej');
    tit.textContent = datos.titulo;
    document.title = datos.title;
    pest.querySelectorAll('a').forEach(function(a){
      a.classList.toggle('on', a.pathname === new URL(url, location.href).pathname);
    });
    if (empuja) history.pushState({ cat: url }, '', url);
    /* si el usuario ya había bajado, la retícula nueva empieza donde estaba la
       vieja; no se le manda arriba */
    var y = tit.getBoundingClientRect().top;
    if (y < 0) tit.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  function cambia(url, empuja){
    rej.style.transition = 'opacity .18s'; rej.style.opacity = '.45';
    trae(url).then(function(d){ pinta(url, d, empuja); })
      .catch(function(){ location.href = url; });   // la ruta lenta, que siempre funciona
  }

  pest.addEventListener('click', function(e){
    var a = e.target.closest('a'); if (!a || a.origin !== location.origin) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;  // pestaña nueva: que la abra
    e.preventDefault();
    if (a.classList.contains('on')) return;
    cambia(a.href, true);
  });
  window.addEventListener('popstate', function(e){
    if (e.state && e.state.cat) cambia(e.state.cat, false);
    else if (history.state === null) cambia(location.href, false);
  });
  history.replaceState({ cat: location.href }, '', location.href);

  /* precarga en silencio, sólo cuando no hay nada mejor que hacer */
  var ocio = window.requestIdleCallback || function(f){ setTimeout(f, 1200); };
  ocio(function(){
    pest.querySelectorAll('a:not(.on)').forEach(function(a){
      if (a.origin === location.origin) trae(a.href).catch(function(){});
    });
  });
})();

/* el menú se cierra al elegir cualquier destino — también anclas de la misma página */
(function(){
  var m=document.getElementById('menu'); if(!m)return;
  m.addEventListener('click',function(e){ if(e.target.closest('a'))cerrarMenu() });
})();

/* carrito: más/menos ajusta la cantidad y actualiza solo, sin botón aparte */
(function(){
  var f=document.getElementById('formaCarrito'); if(!f)return;

  /* CAMBIAR UNA CANTIDAD NO RECARGA LA PÁGINA.
     Antes cada toque en «+» hacía `f.submit()`: parpadeo, scroll de vuelta
     arriba y espera de red completa, en el último tramo antes de pagar.
     Ahora se le pide el cambio a la API del carrito y se repintan sólo los
     números. Si algo falla —sin red, respuesta rara— se envía el formulario
     como siempre: la ruta lenta sigue existiendo, sólo dejó de ser la única.

     Se identifica cada línea por su LLAVE, no por su número: al quitar una
     pieza los números se recorren y el siguiente apuntaría a otra cosa. */
  var moneda=f.dataset.moneda||'MXN', fmt=null;
  // Sin centavos: es como lo pinta el filtro `money` de la tienda ($2,100). Con
  // decimales aquí, el ± hacía que el mismo total cambiara de forma.
  try{ fmt=new Intl.NumberFormat('es-MX',{style:'currency',currency:moneda,minimumFractionDigits:0,maximumFractionDigits:0}); }catch(e){}
  function dinero(cent){ return fmt?fmt.format(cent/100):'$'+Math.round(cent/100).toLocaleString('es-MX'); }

  var ocupado=false;
  function pinta(c){
    if(!c||!c.items) { location.reload(); return; }
    if(c.item_count===0){ location.reload(); return; }   // el vacío lo pinta Liquid
    [].forEach.call(document.querySelectorAll('.citem'),function(el){
      // Por VARIANTE, no por llave: con un código aplicado Shopify recalcula la
      // llave en cada cambio y ninguna fila se reconocía → se quitaban todas y
      // el total se quedaba solo. La llave se renueva desde la respuesta.
      var it=null, k=el.dataset.clave, vid=String(el.dataset.variante||'');
      for(var j=0;j<c.items.length;j++){
        if(c.items[j].key===k || (vid && String(c.items[j].variant_id)===vid)){ it=c.items[j]; break; }
      }
      if(!it){ el.remove(); return; }
      el.dataset.clave=it.key;
      var pr=el.querySelector('[data-precio]'); if(pr) pr.textContent=dinero(it.final_line_price);
      var inp=el.querySelector('.qty input'); if(inp) inp.value=it.quantity;
    });
    var sub=document.getElementById('cSub');
    if(sub) sub.textContent=dinero(c.total_price)+' '+moneda;
    var d=document.getElementById('cDesc');
    if(d){
      if(c.total_discount>0){
        // /cart.js manda el descuento PLANO ({title…}); /cart/change.js lo manda
        // ENVUELTO ({amount, discount_application:{title…}}). Leer `title` en el
        // nivel equivocado pintaba «DESCUENTO · UNDEFINED» tras tocar ±.
        var nombres=(c.cart_level_discount_applications||[]).map(function(a){
          var d=a.discount_application||a; return d.title?' · '+d.title:'';
        }).join('');
        if(!nombres && c.discount_codes && c.discount_codes.length) nombres=' · '+c.discount_codes[0].code;
        d.innerHTML='<div class="ctot csub"><span class="mono">subtotal</span><b>'+dinero(c.items_subtotal_price)+'</b></div>'
                   +'<div class="ctot cdesc"><span class="mono">descuento'+nombres+'</span><b>\u2212'+dinero(c.total_discount)+'</b></div>';
      } else d.innerHTML='';
    }
    msi6(c.total_price);
    var n=document.querySelector('.nav .cart i'); if(n) n.textContent=c.item_count;
    hueco();
  }
  /* La barra de abajo es fija y ahora crece (subtotal, descuento, borde del
     iPhone): el hueco que deja la página tiene que medirse, no adivinarse. */
  function hueco(){
    var b=document.querySelector('.cbarra'), pag=document.querySelector('.cpag');
    if(b && pag) pag.style.paddingBottom=(b.offsetHeight+28)+'px';
  }
  hueco(); window.addEventListener('resize', hueco);
  /* El ±cantidad repinta el total sin recargar, pero la invitación de los 6 MSI
     era Liquid: se quedaba con lo calculado al abrir. Con dos anillos ($3,000)
     seguía diciendo «te faltan $1,000». El umbral se lee del atributo que pone
     la plantilla —una sola fuente— y aquí se rehace el renglón que toque:
     palomita si califica, invitación si falta, nunca los dos. */
  function msi6(total){
    var ul=document.querySelector('.cprom'); if(!ul) return;
    var min=parseInt(ul.dataset.msi6,10); if(!min) return;
    var li=ul.querySelector('[data-msi] span');
    var inv=ul.parentNode.querySelector('.cmsi6'); if(inv) inv.remove();
    if(total>=min){
      if(li) li.textContent='6 meses sin intereses en este pedido';
    } else {
      if(li) li.textContent='3 meses sin intereses';
      /* Ya NO se pinta «Te faltan $X…» (11-sep-2026): invitar a gastar más dentro del
         carrito manda de vuelta al catálogo justo cuando tocaba pagar. El renglón de
         arriba ya dice a cuántos meses va este pedido, y con eso basta. */
    }
  }
  function pide(cuerpo){
    return fetch('/cart/change.js',{method:'POST',headers:{
        'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(cuerpo)})
      .then(function(r){ if(!r.ok) throw new Error('carrito'); return r.json(); });
  }
  /* LA LLAVE CADUCA; EL RENGLÓN NO.
     Shopify recalcula la llave de cada línea cuando el carrito cambia en otra
     pestaña o cuando vuelve a aplicar un descuento —y esta tienda trae uno
     automático—, así que la que pintó Liquid puede ya no existir. Entonces
     /cart/change.js contesta 400 y el carrito se queda igual.

     Antes eso caía en `f.submit()`, y ahí estaba el daño: ese formulario
     reenvía las cantidades TAL COMO ESTÁN en los campos, y el botón de quitar
     nunca las pone en cero. O sea que el respaldo volvía a pedir el carrito
     que ya había, la pieza reaparecía al recargar, y quitarla se veía
     sencillamente imposible.

     > Un respaldo que reenvía el estado viejo no es un respaldo: es deshacer
     > lo que la persona acaba de pedir, y encima parece una falla del sitio.

     Ahora, si la llave falla, se relee el carrito y se reintenta por NÚMERO de
     renglón, que se calcula al momento y por eso no puede estar caduco. Y si
     ni eso, se recarga: repintar de cero siempre dice la verdad. */
  function cambia(clave,cant,fila){
    if(ocupado) return; ocupado=true; f.classList.add('cargando');
    if(cant===0&&fila) fila.classList.add('saliendo');
    var vid = fila && fila.dataset.variante;
    pide({id:clave,quantity:cant})
      .catch(function(){
        return fetch('/cart.js',{headers:{'Accept':'application/json'}})
          .then(function(r){ return r.json(); })
          .then(function(c){
            for(var j=0;j<c.items.length;j++)
              if(c.items[j].key===clave ||
                 (vid && String(c.items[j].variant_id)===String(vid)))
                return pide({line:j+1,quantity:cant});
            return c;                       // ya no está: manda el carrito real
          });
      })
      .then(function(c){ ocupado=false; f.classList.remove('cargando'); pinta(c); })
      .catch(function(){ ocupado=false; location.reload(); });
  }

  f.addEventListener('click',function(e){
    var q=e.target.closest('.qbtn');
    if(q){
      var fila=q.closest('.citem'), inp=q.parentNode.querySelector('input');
      var n=Math.max(0,(parseInt(inp.value,10)||0)+parseInt(q.dataset.d,10));
      inp.value=n;                       // responde al dedo antes que la red
      cambia(fila.dataset.clave,n,fila);
      return;
    }
    var x=e.target.closest('[data-quitar]');
    if(x){
      var fx=x.closest('.citem');
      // el href sigue siendo el de Shopify: si no hay JS, quitar funciona igual
      e.preventDefault();
      cambia(fx.dataset.clave,0,fx);
    }
  });
})();

/* ═══ ASÍ SE HACE ══════════════════════════════════════════════════════
   Dos cosas, las dos pensadas para el celular.

   1. EL VIDEO NO SE DESCARGA AL ABRIR LA PÁGINA. Lleva `preload="none"` y la
      fuente se le pone cuando la sección está por entrar en pantalla. Si
      empezara a bajar de inmediato le quitaría ancho de banda al hero, que es
      lo primero que la persona necesita ver — y son 1.8 MB contra los 230 KB
      del logotipo.
   2. SI EL NAVEGADOR NO LO REPRODUCE SOLO, aparece un botón. iOS deja
      reproducir sin permiso sólo si va en silencio y con `playsinline`, y aun
      así lo bloquea en Ahorro de datos o Ahorro de batería. En vez de dar por
      hecho que se reprodujo, se comprueba: si no arrancó, se enciende el botón.
      Y si el sistema pide menos movimiento, ni se intenta: se queda la portada.  */
(function(){
  var cine = document.getElementById('cine');
  if (!cine) return;
  var v = null;                       // se crea cuando la sección se acerca

  /* ═══ QUE ARRANQUE ═══════════════════════════════════════════════════
     EL ELEMENTO NACE COMPLETO. Cinco versiones seguidas el `<video>` existía
     desde el principio sin fuente, y JavaScript le ponía el `src` al acercarse
     la sección. iOS decide si un video puede arrancar solo mirándolo tal como
     está: uno sin fuente no califica, así que quedábamos en la ruta manual de
     `play()` —la que el sistema puede rechazar, y rechazaba—. Cada ronda yo
     ajustaba cuándo mostrar un botón de aviso en vez de mirar por qué no
     arrancaba.

     > Un elemento a medio nacer no es lazy loading: es un elemento que el
     > navegador ya clasificó, y reclasificarlo después no es asunto nuestro.

     Ahora se construye entero —fuente, mudo, bucle, playsinline, autoplay— y
     se inserta al acercarse. Nace válido para la maquinaria de Safari, que
     reproduce los videos mudos en línea cuando entran en pantalla y los pausa
     al salir; y no baja un solo byte antes de insertarse.
     Poner el `src` directo en el HTML también lo arregla, pero cuesta 1.6 MB
     al abrir: `autoplay` obliga a descargar sin importar `preload`. Medido. */
  var enVuelo = false;

  function intenta(){
    if (!v || enVuelo || !v.paused) return;
    enVuelo = true;
    var p = v.play();
    if (!p || !p.then) { enVuelo = false; return; }
    p.then(function(){ enVuelo = false; },
           function(err){ enVuelo = false; DIAG.error = (err && err.name) || 'error'; });
  }

  function crea(){
    if (v) return;
    v = document.createElement('video');
    // los atributos ANTES de insertar: el elemento tiene que estar completo
    // cuando el navegador lo vea por primera vez
    v.id = 'vidTaller';
    v.muted = true; v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');       // iOS lo lee del atributo
    v.setAttribute('webkit-playsinline', ''); // iOS viejo
    v.setAttribute('autoplay', '');
    v.setAttribute('loop', '');
    v.setAttribute('aria-label', 'Deborah trabajando en el taller');
    v.preload = 'auto';
    v.poster = cine.dataset.poster;
    v.width = 720; v.height = 900;
    v.src = cine.dataset.video;
    v.addEventListener('loadeddata', intenta);
    cine.appendChild(v);
    intenta();
  }

  /* El taller subio al segundo lugar de la portada, asi que la seccion ya
     esta a la vista al abrir: el observador disparaba de inmediato y el video
     de 1.85 MB salia a competir por el ancho de banda con el hero — que es
     exactamente lo que este mecanismo existia para evitar. Acercarse dejo de
     ser condicion suficiente.

     La regla ahora es «cuando se acerque Y la pagina ya haya cargado»: el
     hero gana la primera carrera y el video se lleva todo lo que sobra. A un
     scroll de distancia, eso alcanza de sobra. */
  var cargada = document.readyState === 'complete', pendiente = false;
  function pide(){ if (cargada) crea(); else pendiente = true; }
  if (!cargada) addEventListener('load', function(){
    cargada = true; if (pendiente) crea();
  }, { once: true });

  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(e){
      if (e[0].isIntersecting){ pide(); io.disconnect(); }
    }, { rootMargin: '400px' });
    io.observe(cine);
  } else { pide(); }

  /* Un gesto —el que sea— reintenta si algo lo dejó detenido. Pasa por
     `reanuda`, NO por `intenta`: el toque que abre la galería llega a esta
     escucha DESPUÉS de que el visor pausó el video, y llamando a `intenta`
     directo lo volvía a arrancar detrás del visor. */
  var GESTOS = ['touchstart', 'click', 'keydown', 'scroll'];
  function despierta(){
    if (v && !v.paused){ GESTOS.forEach(function(g){ removeEventListener(g, despierta); }); return; }
    if (v) reanuda();
  }
  GESTOS.forEach(function(g){ addEventListener(g, despierta, {passive:true}); });

  /* ═══ MODO DIAGNÓSTICO ═══════════════════════════════════════════════
     `?video=diag` en la URL. No cambia nada del sitio; sólo dibuja encima del
     video lo que el navegador REALMENTE está haciendo. Existe porque el
     problema de fondo no era el video: era no poder ver el teléfono donde
     falla, y mandar arreglos a ciegas ronda tras ronda. */
  var DIAG = { error: '—' };
  if (/[?&]video=diag/.test(location.search)) {
    var caja = document.createElement('div');
    caja.setAttribute('style',
      'position:absolute;left:8px;top:8px;z-index:9;max-width:calc(100% - 16px);' +
      'background:rgba(0,0,0,.82);color:#8ef;font:11px/1.55 ui-monospace,monospace;' +
      'padding:8px 10px;border-radius:8px;white-space:pre-wrap;pointer-events:none');
    cine.appendChild(caja);
    var ESTADOS = ['0 sin datos','1 metadatos','2 dato actual','3 dato futuro','4 suficiente'];
    var RED = ['0 vacío','1 inactivo','2 cargando','3 SIN FUENTE'];
    setInterval(function(){
      var c = navigator.connection || {};
      caja.textContent = !v ? 'el video aún no se ha creado (no has llegado a la sección)' :
        'readyState ' + (ESTADOS[v.readyState] || v.readyState) +
        '\nnetwork    ' + (RED[v.networkState] || v.networkState) +
        '\nerror      ' + (v.error ? 'código ' + v.error.code : 'no') +
        '\npaused     ' + v.paused + '   t=' + v.currentTime.toFixed(1) +
        '\nmuted      ' + v.muted + '   autoplay=' + v.autoplay +
        '\npreload    ' + v.preload +
        '\nsrc        ' + (v.currentSrc || v.src || '—').split('/').pop() +
        '\nplay dijo  ' + DIAG.error +
        '\nmenos-mov  ' + matchMedia('(prefers-reduced-motion:reduce)').matches +
        '\nahorro     ' + (c.saveData === undefined ? '—' : c.saveData) +
        '   red=' + (c.effectiveType || '—');
    }, 400);
  }

  /* AL VOLVER A LA APP, EL VIDEO SIGUE.
     iOS lo pausa al salir de Safari y al regresar quedaba congelado en el
     cuadro donde lo dejó: no parece pausado, parece roto.
     NO se escucha `focus`: dispara también durante la carga de la página. */
  function enPantalla(){
    var r = cine.getBoundingClientRect();
    return r.bottom > 0 && r.top < innerHeight;
  }
  function reanuda(){
    if (!v || !v.paused) return;
    if (visor && visor.classList.contains('on')) return;   // el visor está encima
    if (!enPantalla()) return;
    intenta();
  }
  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState === 'visible') reanuda();
  });
  addEventListener('pageshow', reanuda);

  /* ── LA FOTO A PANTALLA COMPLETA ──
     La imagen grande de cada paso no existe hasta que se toca: en la tira sólo
     viven las miniaturas. */
  var tira = document.getElementById('tiraTaller'),
      fotos = [].slice.call(tira.querySelectorAll('.foto')),
      visor = document.getElementById('visor'),
      img = document.getElementById('visorImg'),
      tx = document.getElementById('visorTx'),
      num = document.getElementById('visorNum'),
      i = 0;

  /* LA FOTO Y EL CONTADOR CAMBIAN JUNTOS.
     Antes se le asignaba `src` y se actualizaba el contador en la misma línea,
     pero el navegador sigue enseñando los píxeles viejos hasta que decodifica
     los nuevos: por un segundo se veía la foto anterior con el número
     siguiente, como si la galería se hubiera trabado.
     Ahora se decodifica ANTES y se cambia todo de golpe. Y al abrir el visor
     se precargan las cinco: es el momento en que la persona ya demostró que
     las quiere ver, así que no le cuesta scroll a nadie más. */
  /* Se declara AQUÍ. Vivía arriba, en el bloque del video, y al reescribir ese
     bloque desapareció — pero la galería la seguía usando. Resultado: cada
     flecha y cada deslizamiento lanzaba `quieto is not defined` y el visor no
     avanzaba. Aquí es donde se usa, así que aquí vive.

     > Una variable que se declara en un bloque y se usa en otro no está
     > compartida: está prestada, y se pierde cuando el prestador cambia. */
  var quieto = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var precargadas = false;
  function precarga(){
    if (precargadas) return; precargadas = true;
    fotos.forEach(function(f){ (new Image()).src = f.dataset.grande; });
  }
  /* PINTAR ES INMEDIATO.
     Aquí había una maquinaria para no enseñar la foto anterior con el contador
     nuevo: se cargaba una imagen aparte, se esperaba a que decodificara y
     recién entonces se cambiaba todo. Medido, esa espera llegaba UN CLIC
     TARDE —la pintura de un toque aparecía al dar el siguiente—, así que las
     flechas parecían muertas.

     > Esperar a que algo esté perfecto antes de responder se siente igual que
     > no responder.

     El desfase que aquella maquinaria evitaba ya está resuelto de otra forma:
     el contador usa el índice de SU llamada, no el vivo, así que número y foto
     no pueden separarse. Y como al abrir el visor se precargan las cinco, el
     cambio es instantáneo de todos modos. */
  function pinta(n, listo){
    var idx = (n + fotos.length) % fotos.length;
    i = idx;
    var f = fotos[idx];
    img.src = f.dataset.grande;
    img.alt = f.dataset.tx;
    tx.textContent = f.dataset.tx;
    num.textContent = (idx + 1) + ' / ' + fotos.length;
    if (listo) listo();
  }
  /* El cambio de foto se desliza hacia el lado del que viene: sin eso, dos
     fotos parecidas se sustituyen sin que se note que cambió algo. Con
     `prefers-reduced-motion` se sustituye y ya. */
  /* NINGÚN TOQUE SE PIERDE.
     Antes había un candado —«si ya está en transición, ignora»— y tres toques
     seguidos avanzaban dos fotos: el de en medio se caía. Medido: 2, 2, 3.
     Un candado no protege la animación, se come la intención de la persona.
     Ahora el índice avanza AL INSTANTE con cada toque y lo que se cancela es
     la transición anterior, no el toque. */
  var temporizador = null;
  function muestra(n, dir){
    if (quieto || dir === undefined) { pinta(n); return; }
    clearTimeout(temporizador);
    i = (n + fotos.length) % fotos.length;
    var destino = i;
    visor.style.setProperty('--dir', (dir > 0 ? -14 : 14) + 'px');
    visor.classList.add('mudando');
    temporizador = setTimeout(function(){
      // el fundido de vuelta espera a que la foto nueva esté decodificada
      pinta(destino, function(){
        visor.style.setProperty('--dir', (dir > 0 ? 14 : -14) + 'px');
        requestAnimationFrame(function(){ visor.classList.remove('mudando'); });
      });
    }, 165);
  }
  function abre(n){ precarga(); pinta(n); visor.classList.add('on');
    document.body.style.overflow = 'hidden';
    /* Se pausa a propósito: tapado por el visor, iOS lo suspende de todos
       modos, y así el estado al cerrar es uno solo y conocido. */
    if (v && !v.paused) v.pause(); }
  function cierra(){
    clearTimeout(temporizador);
    visor.classList.remove('on'); visor.classList.remove('mudando');
    document.body.style.overflow = '';
    /* AL VOLVER, EL VIDEO SIGUE. Antes se quedaba congelado en el cuadro donde
       lo dejó iOS y parecía roto. Si el navegador se niega a reanudar (Ahorro
       de datos, Ahorro de batería), se enciende el botón de reproducir en vez
       de dejar una imagen quieta sin explicación. */
    if (!v) return;
    intenta();
  }

  /* 7-sep: el visor vuelve; ahí se lee la frase de cada foto. `data-fijo` en la tira lo apaga. */
  if (!tira.hasAttribute('data-fijo')) fotos.forEach(function(f, n){ f.addEventListener('click', function(){ abre(n); }); });

  document.getElementById('visorX').addEventListener('click', cierra);
  document.getElementById('visorAnt').addEventListener('click', function(){ muestra(i - 1, -1); });
  document.getElementById('visorSig').addEventListener('click', function(){ muestra(i + 1, 1); });
  visor.addEventListener('click', function(e){ if (e.target === visor) cierra(); });
  addEventListener('keydown', function(e){
    if (!visor.classList.contains('on')) return;
    if (e.key === 'Escape') cierra();
    if (e.key === 'ArrowLeft') muestra(i - 1, -1);
    if (e.key === 'ArrowRight') muestra(i + 1, 1);
  });
  /* deslizar con el dedo entre fotos */
  var x0 = null;
  visor.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
  visor.addEventListener('touchend', function(e){
    if (x0 === null) return;
    var d = e.changedTouches[0].clientX - x0;
    if (Math.abs(d) > 45) muestra(i + (d < 0 ? 1 : -1), d < 0 ? 1 : -1);
    x0 = null;
  }, {passive:true});
})();
